<template>
    <ContentLoader
        :height="600"
        :width="1500"
        :speed="2"
        primaryColor="#fcfcfc"
        secondaryColor="#f9f9f9"
    >
        <rect x="0" y="0" rx="5" ry="5" width="105" height="40" />
        <rect x="0" y="40" rx="5" ry="5" width="770" height="240" />
        <rect x="0" y="315" rx="5" ry="5" width="770" height="285" />
    </ContentLoader>
</template>

<script>
    import { ContentLoader } from 'vue-content-loader'
    export default {
        name: "RequestsLoader",
        components: {ContentLoader}
    }
</script>

<style scoped>

</style>
